import arrowIcon from "assets/images/black-arrow-icon.svg";
import classNames from "classnames";
import {Link} from "react-router-dom";

import styles from "./AccountLink.module.css";

type Props = {
  className?: string;
  label: string;
  to?: string;
  onChange?: () => void;
};

export default function AccountLink(props: Props) {
  return props.to ? (
    <Link
      to={props.to}
      className={classNames(styles.container, props.className)}
    >
      <span className={styles.label}>{props.label}</span>
      <img className={styles.icon} src={arrowIcon} alt="" />
    </Link>
  ) : (
    <button
      onClick={props.onChange}
      className={classNames(styles.container, props.className)}
    >
      <span className={styles.label}>{props.label}</span>
      <img className={styles.icon} src={arrowIcon} alt="" />
    </button>
  );
}
